import { SMALL, MEDIUM, LARGE } from "shared/utils/constants";
import cx from "classnames";
import styles from "./MaxWidth.module.css";

export const MaxWidth = ({ children, size }) => {
  const classNames = cx(styles.container, {
    [styles.small]: size === SMALL,
    [styles.medium]: size === MEDIUM,
    [styles.large]: size === LARGE,
  });

  return <div className={classNames}>{children}</div>;
};
